/* globals RTCSessionDescription */
'use strict';

module.exports = RTCSessionDescription;